import React from 'react';
import Image from 'next/image';
import type { NewsAEMImages } from '../../../interfaces/NewsAEM.interface';

interface NewsBannerProps {
  bannerLink?: string | null;
  title: string;
  fallbackImage?: string;
  className?: string;
  aemImages?: NewsAEMImages;
}

const NewsBanner: React.FC<NewsBannerProps> = ({
  bannerLink,
  title,
  fallbackImage,
  className = '',
  aemImages,
}) => {
  const defaultBanner = aemImages?.defaultNewsBanner ?? '';
  const finalFallback = fallbackImage ?? defaultBanner;
  const imageSrc = bannerLink ?? finalFallback;

  return (
    <Image
      src={imageSrc}
      alt={title}
      width={226}
      height={127}
      quality={25}
      className={className}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        if (target.src !== finalFallback) {
          target.src = finalFallback;
        }
      }}
    />
  );
};

export default NewsBanner;

